import { render, staticRenderFns } from "./BotCollaborationSettings.vue?vue&type=template&id=c96d92e2"
import script from "./BotCollaborationSettings.vue?vue&type=script&lang=ts"
export * from "./BotCollaborationSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports